import dayjs from 'dayjs';
import { ICustomer } from 'app/shared/model/customer.model';
import { IDeal } from 'app/shared/model/deal.model';
import { UserDealStatus } from 'app/shared/model/enumerations/user-deal-status.model';

export interface IUserDeals {
  id?: string;
  customerId?: string | null;
  status?: keyof typeof UserDealStatus | null;
  createdAt?: dayjs.Dayjs | null;
  updatedAt?: dayjs.Dayjs | null;
  expired?: boolean | null;
  customer?: ICustomer | null;
  deal?: IDeal | null;
}

export const defaultValue: Readonly<IUserDeals> = {
  expired: false,
};
